import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-modal';
import { Link as Anchor, useLocation } from 'react-router-dom';
import logo from '../../images/4.png';
import baseURL from '../url';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile';
import './Navbar.css';

import Favoritos from '../Favoritos/Favoritos';
import InputSerach from '../InputSerach/InputSearchs';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [brands, setBrands] = useState([]);
    const [isStockDropdownOpen, setIsStockDropdownOpen] = useState(false);
    const location = useLocation();
    const dropdownRef = useRef(null);

    const fetchBrands = () => {
        fetch(`${baseURL}/marcasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setBrands(data?.marca?.slice(0, 7) || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const isBrandActive = (idMarca) => location.state?.idMarca === idMarca;

    useEffect(() => {
        cargarBanners();
        fetchBrands();
    }, []);

    // Cerrar dropdown al hacer clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsStockDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const bannerImages = data.banner.map(banner => banner.imagen);
                setImages(bannerImages);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error);
            });
    };

    // Función para cerrar el modal cuando se hace clic en un enlace
    const handleLinkClick = () => {
        setIsOpen(false);
    };

    // Función para verificar si la ruta está activa
    const isActive = (path) => {
        return location.pathname === path;
    };

    // Función para verificar si alguna ruta del stock está activa
    const isStockActive = () => {
        return location.pathname === '/stock' ||
            location.pathname === '/stock/motos' ||
            location.pathname === '/stock/autos';
    };

    // Manejar click en Stock (toggle dropdown)
    const handleStockClick = (e) => {
        e.preventDefault();
        setIsStockDropdownOpen(!isStockDropdownOpen);
    };

    // Manejar el clic en el enlace de Motos para mostrar el mensaje de "Próximamente"
    const handleMotosClick = (e) => {
        handleDropdownItemClick();
    };

    // Cerrar dropdown al seleccionar una opción
    const handleDropdownItemClick = () => {
        setIsStockDropdownOpen(false);
    };

    return (
        <>
            <header>
                <nav>
                    <Anchor to={`/`} className='logo'>
                        <img src={logo} alt="logo" />
                    </Anchor>

                    {/* Menú desktop horizontal */}
                    <div className='desktop-menu'>
                        <Anchor
                            to="/"
                            className={isActive('/') ? 'active' : ''}
                        >
                            Inicio
                        </Anchor>

                        {/* Dropdown para Stock */}
                        <div
                            className={`dropdown ${isStockActive() ? 'active' : ''} ${isStockDropdownOpen ? 'open' : ''}`}
                            ref={dropdownRef}
                        >
                            {/* Quitamos las flechas manuales para que solo quede la del CSS */}
                            <button
                                className="dropdown-toggle"
                                onClick={handleStockClick}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', font: 'inherit' }}
                            >
                                Stock
                            </button>

                            <div className="dropdown-menu">
                                <Anchor
                                    to="/stock/motos"
                                    className={`dropdown-item ${isActive('/stock/motos') ? 'active' : ''}`}
                                    onClick={handleMotosClick}
                                >
                                    🏍️ Motos
                                </Anchor>
                            </div>
                        </div>

                        <Anchor
                            to="/financiacion"
                            className={isActive('/financiacion') ? 'active' : ''}
                        >
                            Financiacion
                        </Anchor>

                        <Anchor
                            to="/nosotros"
                            className={isActive('/nosotros') ? 'active' : ''}
                        >
                            Nosotros
                        </Anchor>
                    </div>

                    <div className='deFLexNavs'>
                        <div className={`nav_toggle  ${isOpen && "open"}`} onClick={() => setIsOpen(!isOpen)}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>

                    {/* Modal para móviles */}
                    <Modal
                        isOpen={isOpen}
                        onRequestClose={() => setIsOpen(false)}
                        className="modalNav"
                        overlayClassName="overlay"
                    >
                        <div className="modalNav-content">
                            {loading ? (
                                <div className='loadingBannerFondo'>
                                </div>
                            ) : (
                                <>
                                    <div className='fondo'>
                                        <img src={images[0]} alt={`imagen`} />
                                    </div>

                                    <div className='enlaces'>
                                        <Anchor to="/" onClick={handleLinkClick}>
                                            INICIO
                                        </Anchor>

                                        <Anchor to="/stock/motos" onClick={handleMotosClick} className="mobile-sub-item">
                                            &nbsp;&nbsp; MOTOS
                                        </Anchor>

                                        <Anchor to="/financiacion" onClick={handleLinkClick}>
                                            FINANCIACIÓN
                                        </Anchor>

                                        <Anchor to="/nosotros" onClick={handleLinkClick}>
                                            NOSOTROS
                                        </Anchor>
                                    </div>

                                    <Profile />
                                </>
                            )}
                        </div>
                    </Modal>
                </nav>
                <div className="brands-bar">
                    <div className="brands-inner">
                        {brands.map((brand) => (
                            <Anchor
                                key={brand.idMarca}
                                to="/motos"
                                state={{ idMarca: brand.idMarca }}
                                className={`brand-item ${isBrandActive(brand.idMarca) ? 'active' : ''}`}
                            >
                                {brand.nombre}
                            </Anchor>
                        ))}
                    </div>
                </div>
            </header>
            <div className='nav-spacer'></div>
        </>
    );
}